module.exports = __webpack_public_path__ + "img/chofu_tourist_off.6e78516d.svg";